import axios from 'axios';
import { toast } from 'react-toastify';
import { assetURL } from '../../api/utils';

// export const LOADER = "LOADER";
// export const loader = (bool) => ({
//   type: 'LOADER',
//   payload: bool,
// });

// export const Action = () => {
//
//   return async (dispatch) => {

//     dispatch(loader(true))
//     dispatch(Data(process.env.REACT_BASE_URL))
//     dispatch(loader(false))

//   }
// };
// export const DATA = "DATA";
// export const Data = (payload) => ({
//   type: 'Data',
//   payload: payload,
// });

export const ADD_ARTICLE_LOADER = 'ADD_ARTICLE_LOADER';
export const addArticleLoader = bool => ({
  type: 'ADD_ARTICLE_LOADER',
  payload: bool,
});

export const AddArticleAction = (obj, clearState) => {
  return async dispatch => {
    dispatch(addArticleLoader(true));
    let data = new FormData();

    data.append('titleName', obj.titleName);
    if (obj.pdf_file) {
      data.append('fileName', obj.pdf_file.name);
      data.append('pdf_file', obj.pdf_file);
    }

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/articles/create`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        clearState();
        dispatch(addArticleLoader(false));
        dispatch(GetArticleAction());
        toast.success('Article Has Been Published');
      })
      .catch(error => {
        dispatch(addArticleLoader(false));
        toast.error(error?.response?.data?.message || 'Something went wrong');
      });
  };
};
export const ADD_ARTICLE_DATA = 'ADD_ARTICLE_DATA';
export const AddArticleData = payload => ({
  type: 'ADD_ARTICLE_DATA',
  payload: payload,
});

export const GET_ARTICLE_LOADER = 'GET_ARTICLE_LOADER';
export const getArticleLoader = bool => ({
  type: 'GET_ARTICLE_LOADER',
  payload: bool,
});

export const GetArticleAction = () => {
  return async dispatch => {
    // dispatch(addArticleLoader(true))

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/articles/getall`,
      headers: {},
    };

    axios(config)
      .then(response => {
        dispatch(GetArticleData(response.data.data));
      })
      .catch(error => {});
  };
};
export const GET_ARTICLE_DATA = 'GET_ARTICLE_DATA';
export const GetArticleData = payload => ({
  type: 'GET_ARTICLE_DATA',
  payload: payload,
});

export const DELETE_ARTICLE_LOADER = 'DELETE_ARTICLE_LOADER';
export const deleteArticleLoader = bool => ({
  type: 'DELETE_ARTICLE_LOADER',
  payload: bool,
});

export const DeleteArticleAction = (id, handleDeleteOk) => {
  return async dispatch => {
    dispatch(deleteArticleLoader(true));

    let config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/articles/delete/${id}`,
      headers: {},
    };

    axios(config)
      .then(response => {
        dispatch(GetArticleData(response.data.data));
        dispatch(deleteArticleLoader(false));
        if (handleDeleteOk) {
          handleDeleteOk();
        }
        toast.success('Article Has Been Deleted');
      })
      .catch(error => {
        dispatch(deleteArticleLoader(false));
        toast.error('Something went wrong');
      });
  };
};
export const DELETE_ARTICLE_DATA = 'DELETE_ARTICLE_DATA';
export const deleteArticleData = payload => ({
  type: 'DELETE_ARTICLE_DATA',
  payload: payload,
});

export const UPADTE_ARTICLE_LAODER = 'UPADTE_ARTICLE_LAODER';
export const updateArticleLoader = bool => ({
  type: 'UPADTE_ARTICLE_LAODER',
  payload: bool,
});

export const UpdateArticleAction = (obj, handleOk, setEditDataLoader) => {
  return async dispatch => {
    dispatch(updateArticleLoader(true));
    let data = new FormData();

    data.append('titleName', obj.titleName);
    data.append('pdf_file', obj.pdf_file);

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/articles/update/${obj._id}`,
      data: data,
    };

    axios(config)
      .then(response => {
        dispatch(GetArticleData(response.data.data));
        dispatch(updateArticleLoader(false));
        if (handleOk) {
          handleOk();
          setEditDataLoader(false);
        }
        toast.success('Article Has Been Updated');
      })
      .catch(error => {
        dispatch(updateArticleLoader(false));
        setEditDataLoader(false);
        toast.error('Something went wrong');
      });
  };
};
export const UPDATE_ARTICLE_DATA = 'UPDATE_ARTICLE_DATA';
export const updateArticleData = payload => ({
  type: 'UPDATE_ARTICLE_DATA',
  payload: payload,
});

export const DOWNLOAD_ARTICLE_FILE_LAODER = 'DOWNLOAD_ARTICLE_FILE_LAODER';
export const downloadArticleFileLoader = bool => ({
  type: 'DOWNLOAD_ARTICLE_FILE_LAODER',
  payload: bool,
});

export const DownloadArticleFileAction = filename => {
  return async dispatch => {
    dispatch(downloadArticleFileLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${assetURL}${filename}`,
      // data: obj
    };

    axios(config)
      .then(response => {
        dispatch(downloadArticleFileLoader(false));
        // toast.success('Your file is being download');
      })
      .catch(error => {
        dispatch(downloadArticleFileLoader(false));
      });
  };
};
export const DOWNLOAD_ARTICLE_FILE = 'DOWNLOAD_ARTICLE_FILE';
export const downloadArticleFile = payload => ({
  type: 'DOWNLOAD_ARTICLE_FILE',
  payload: payload,
});

export const GET_SEARCH_ARTICLE_LOADER = 'GET_SEARCH_ARTICLE_LOADER';
export const getSearchArticleLoader = bool => ({
  type: 'GET_SEARCH_ARTICLE_LOADER',
  payload: bool,
});

export const GetSearchArticleAction = text => {
  return async dispatch => {
    dispatch(getSearchArticleLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/articles/get?titleName=${text}`,
    };

    axios(config)
      .then(response => {
        dispatch(GetArticleData(response.data.data));
      })
      .catch(error => {});
  };
};
export const GET_SEARCH_ARTICLE_DATA = 'GET_SEARCH_ARTICLE_DATA';
export const GetSearchArticleData = payload => ({
  type: 'GET_SEARCH_ARTICLE_DATA',
  payload: payload,
});
